import styles from './CategoryProductCard.module.scss';
import { Box, Typography } from '@mui/material';
import Image from 'next/image';
import imgLoader from '../../../../../imgloader';
import Router from 'next/router';
import { TextWithArrowAnimation } from '../../../../hoc';

const CategoryProductCard = ({
  title,
  description,
  image,
  price,
  url = '/',
}) => {
  return (
    <Box className={styles.cardContainer}>
      <div
        className={styles.imageContainer}
        onClick={() => {
          Router.push(
            {
              pathname: url,
            },
            url
          );
        }}
      >
        <Image
          src={image}
          alt={title}
          loader={imgLoader}
          layout="fill"
          placeholder="blur"
          blurDataURL={image}
        />
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.headingContent}>
          <Typography
            variant="h3"
            className={styles.title}
            onClick={() => {
              Router.push(
                {
                  pathname: url,
                },
                url
              );
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="p1-book"
            className={styles.description}
            onClick={() => {
              Router.push(
                {
                  pathname: url,
                },
                url
              );
            }}
          >
            {description}
          </Typography>
        </div>
        <div className={styles.priceContainer}>
          <Box
            className={styles.cta}
            onClick={() => {
              Router.push(
                {
                  pathname: url,
                  hash: 'buy',
                },
                url
              );
            }}
          >
            <TextWithArrowAnimation>Learn More</TextWithArrowAnimation>
          </Box>
        </div>
      </div>
    </Box>
  );
};

export default CategoryProductCard;
